import { QUERY_KEYS } from "@/services/KEYS/QUERY_KEYS";
import { CORE_URLS } from "@/services/URLS/CORE_URLS";
import { useQuery } from "@tanstack/react-query";
import { IUserResponseSchema } from "./user.types";
import { handleGlobalGetRequestQuery } from "@/lib/httpFunction/globalApiFunction";

export const useSingleUserService = () => {
  const getSingleUserService = useQuery({
    queryKey: [...QUERY_KEYS.USER],
    queryFn: (): Promise<{ data: IUserResponseSchema }> =>
      handleGlobalGetRequestQuery({ url: CORE_URLS.USER }),
  });

  return {
    services: { getSingleUserService },
  };
};
